"use client";

import React from "react";
import { Box } from "@mui/material";
import { FlexibleCard as FlexibleCardType } from "@/types/dto/flexible-card-layout-section";
import {ColletteCarousel} from "@collette-travel/collette-common-controls";
import useMediaQuery from "@mui/material/useMediaQuery";
import {Theme} from "@mui/material/styles";
import FlexibleCard from "../flexible-card";

interface CarouselLayoutProps {
  cards: FlexibleCardType[];
}

const CarouselLayout: React.FC<CarouselLayoutProps> = ({ cards }) => {
  const isLg = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));
  return (
    <Box className="flexible-card-carousel-layout">
      <ColletteCarousel
        testId="flexible-card-carousel"
        variant="full-width"
        arrowPosition={isLg ? "sides" : "bottom"}
        showDots={isLg}
      >
        {cards.slice(0, 6).map((card, index) => (
          <FlexibleCard
            key={`carousel-${card.tour?.id || "no-tour"}`}
            card={card}
            index={index}
          />
        ))}
      </ColletteCarousel>
    </Box>
  );
};

export default React.memo(CarouselLayout);
